module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-alert', {
    staticClass: "alert-top",
    attrs: {
      "variant": _vm.variant,
      "dismissible": "",
      "show": _vm.show
    },
    on: {
      "dismissed": function($event) {
        _vm.show = false
      }
    }
  }, [(_vm.variant === 'danger') ? _c('a', {
    staticClass: "alert-link",
    attrs: {
      "href": _vm.link
    }
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")]) : _c('a', [_vm._v(" " + _vm._s(_vm.message) + " \n      "), (_vm.link) ? _c('b-link', {
    attrs: {
      "to": _vm.link
    },
    on: {
      "click": _vm.disposeNotification
    }
  }, [_vm._v(_vm._s(_vm.linkDescription))]) : _vm._e()], 1), _vm._v(" "), (_vm.showList) ? _c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', [_c('b-link', {
      attrs: {
        "href": item.link
      },
      on: {
        "click": _vm.disposeNotification
      }
    }, [_vm._v(_vm._s(item.msg))])], 1)
  }), 0) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8e5c6624", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e5c6624","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/alert-container/AlertContainer.vue
// module id = 799
// module chunks = 1